<script setup lang="ts">
import { StrapiBlocks, type BlocksContent } from "vue-strapi-blocks-renderer";
import Glide from "@glidejs/glide";

const route = useRoute();
const config = useRuntimeConfig();
// import "slick-carousel"
//import $ from "jquery";
const { data: artwork, error } = await useFetch<Artwork>(`/api/artworks/${route.params.slug}`);



if (error.value) {
  // page 500
  throw createError({ statusCode: 500, statusMessage: "Failed to fetch artwork data" });
}
const imageUrl = (index: number) => {
  return `${config.public.metApiBaseUrl}${artwork.value?.images[index]?.url!}`;
};

useHead({
  title: `${artwork.value?.title}`,
});

const showContactForm = ref(false);
const onClickContactForm = () => {
  showContactForm.value = !showContactForm.value;
};

const onSubmittedEvent = (status: boolean) => {
  showContactForm.value = !status;
};

const carousel = ref<Glide>(new Glide(".glide"));
const isCarouselFullview = ref(false);
const onClickImage = async (event: Event) => {
  isCarouselFullview.value = !isCarouselFullview.value;

  // carousel.value.destroy();
  // await nextTick();
  // // carousel.value.update();
  // carousel.value = new Glide(".glide");
  // carousel.value.mount();
  await nextTick();
  carousel.value.update();
};

onMounted(async () => {
  if (!import.meta.client) return;
  carousel.value.mount();
  // @ts-ignore
  // await import("slick-carousel");
  // const commonSlider = $(".single-post-slider, .single-project-slider");
  // // @ts-ignore
  // commonSlider.slick({
  //   autoplay: false,
  //   dots: true,
  //   infinite: false,
  //   fade: false,
  //   speed: 300,
  //   slidesToShow: 1,
  //   adaptiveHeight: false,
  //   arrows: true,
  // });
});
</script>
<template>
  <div class="content">
    <!-- Breadcrumb area start -->
    <Breadcumb :title="artwork?.title || 'Artwork'" :subtitle="artwork?.categoria.title || 'Artwork details'"
      :items="[{ text: artwork?.categoria.title!, href: `/artworks/${artwork?.categoria.slug}` }]"
      :to="{ text: artwork?.title || 'Artwork', href: `` }" />
    <!-- Breadcrumb area end -->
    <!-- Single Project area -->
    <div class="single-project-area xboot-standard-row gray-bg" style="padding-top: 0%">
      <div class="fluid-container">
        <div class="row">
          <div class="col-lg-12 col-md-12"
            :class="{ 'carousel-fullview': isCarouselFullview, 'carousel-smallview': !isCarouselFullview }">
            <!-- <div class="single-project-slider single-project-thumb-wrapper">
              <a v-for="(value, index) in artwork?.images" :key="value.id" :href="imageUrl(index)" data-lightbox="img-gallery"><img height="600" :src="imageUrl(index)" :alt="artwork?.title" /></a>
            </div> -->

            <div class="glide" style="height: 100%">
              <div class="glide__track" data-glide-el="track" style="height: 100%">
                <ul class="glide__slides" style="height: 100%">
                  <li class="glide__slide" v-for="(value, index) in artwork?.images" :key="value.id"
                    style="height: 100%">
                    <img @click="onClickImage" style="object-fit: contain; height: 100%; width: 100%"
                      :src="imageUrl(index)" :alt="artwork?.title" />
                  </li>
                </ul>
              </div>
              <div v-if="artwork?.images && artwork?.images.length > 1" class="glide__arrows" data-glide-el="controls">
                <button class="glide__arrow glide__arrow--left" data-glide-dir="<"><i
                    class="ti-arrow-left"></i></button>
                <button class="glide__arrow glide__arrow--right" data-glide-dir=">"><i
                    class="ti-arrow-right"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container" style="padding-top: 120px">
        <div class="row">
          <div class="col-lg-3 col-md-4 col-sm-12">
            <div class="project-meta-wrapper artwork-info-widget">
              <h4 class="widget-title">Artwork info</h4>
              <ul class="single-portfolio-meta">
                <li v-for="(item, index) in artwork?.infos" :key="index">
                  <span class="tag-keyword">{{ item.chiave }}:</span>
                  <span class="tag-value">{{ item.valore }}</span>
                </li>

                <li v-if="artwork?.video && artwork?.video.length > 0">
                  <span class="tag-keyword">Video: </span><a class="tag-value" v-for="(value, index) in artwork?.video"
                    :key="index" :href="value.youtube">{{ `${artwork?.title}-${artwork.video.length > 1 ? index + 1 :
                    ""} on YouTube` }}<i class="ti-arrow-top-right"></i></a>
                </li>
                <li v-if="artwork?.audio && artwork?.audio.length > 0">
                  <span class="tag-keyword">Audio: </span><a class="tag-value" v-for="(value, index) in artwork?.audio"
                    :key="index" :href="value.url">{{ `${artwork?.title}-${artwork.audio.length > 1 ? index + 1 : ""} on
                    SoundCloud` }}<i class="ti-arrow-top-right"></i></a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-9 col-md-8 col-sm-12">
            <div class="single-project-description">
              <h2 class="single-project-title">
                {{ artwork?.title }}
              </h2>
              <div v-if="artwork?.video && artwork?.video.length > 0" style="margin-bottom: 2rem">
                <YouTubePlayer v-for="(value, index) in artwork?.video" :key="index" :url="value.youtube" />
              </div>
              <div v-if="artwork?.audio && artwork?.audio.length > 0" style="margin-bottom: 2rem">
                <AudioPlayer v-for="(value, index) in artwork?.audio" :key="index" :track="value"/>
              </div>
              <StrapiBlocks :content="artwork?.description || []" />
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 gray-bg">
            <div class="contact-form gray-bg" :style="{ paddingBottom: showContactForm == false ? '20px' : '0' }">
              <div class="section-title text-left gray-bg" @click="onClickContactForm"
                :style="{ marginBottom: showContactForm ? '1rem' : '0', width: '100%', marginRight: '0' }">
                <h4 class="contact-title widget-title">Inquire</h4>
                <div class="show-form-container">
                  <p>{{ showContactForm == false ? "Click to ask a question" : "Ask me anything about this artwork" }}
                  </p>
                  <i :class="{ 'ti-angle-down': !showContactForm, 'ti-angle-up': showContactForm }"></i>
                </div>
              </div>
              <ContactForm v-if="showContactForm" @submitted="onSubmittedEvent" :artwork-name="artwork?.title"
                :artwork-id="artwork?.id" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Single Project area end -->
  </div>
</template>
<style>
.slick-arrow,
.slick-arrow::before {
  opacity: 1;
  color: var(--primary-color);
  visibility: visible;
}
.single-portfolio-meta {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: flex-start;
  align-items: flex-start;
  justify-content: center;
}
.single-portfolio-meta > li {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.slick-slide img {
  height: 600px;
  object-fit: contain;
  background-color: var(--background-color);
  padding: 0;
  border-top: var(--border-color);
}

.contact-form {
  margin-top: 2rem;
  background: var(--background-color) none repeat scroll 0 0;
  border: 1px solid #f0f0f0;
  padding: 2rem;
}
.contact-title {
  color: var(--title-color);
}
</style>
<style scoped>
.tag-keyword {
  color: var(--subtitle-color);
}
.tag-value {
  color: var(--paragraph-color);
}

.show-form-container {
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.show-form-container p,
.show-form-container i {
  color: var(--subtitle-color);
}
.show-form-container:hover p {
  transition: all 0.3s ease;
  text-decoration: underline solid var(--primary-color) 2px;
}
.show-form-container:hover p,
.show-form-container:hover i {
  transition: all 0.3s ease;

  color: var(--primary-color);
  cursor: pointer;
}
.artwork-info-widget {
  background-color: var(--background-color);
  color: var(--title-color);
}

.carousel-smallview {
  height: 600px;
}
.carousel-fullview {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background-color: black;
}
</style>
